import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { apiPut } from "../../../utils/apiFetch";
import { useNavigate, useLocation } from "react-router-dom";
import apiPath from "../../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import OFile from "components/reusable/OFile";
import helper from "../../../utils/helpers";
import { BiArrowBack } from "react-icons/bi";
const ViewPostDetails = (item, userDetails) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(
    location?.state?.item?.images || null
  );
  const [uploadedVideos, setUploadedVideos] = useState(
    location?.state?.item?.videos || null
  );
  const [uploadedAudio, setUploadedAudio] = useState(
    location?.state?.item?.audio || null
  );
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state?.item);
  const notification = useToastContext();
  const {
    register,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      likes: editData?.likes,
      mobile: editData?.userDetails?.mobile,
      createdAt: helper?.dateFormat(editData?.createdAt) || t("O_N/A"),
      comments: editData?.comments,
      postReportCount: editData?.postReportCount,
      postSaveCount: editData?.postSaveCount,
      description: editData?.description,

    },
});

  const getBack = () => {
    setRedirect(true);
    navigate("/users/customer-view",{ state: { from: 'posts', userDetails: location.state.userDetails } });
  };

  const handelDelete = async (item) => {
    try {
      const path = apiPath.deletePost + "/" + item?._id;
      const result = await apiPut(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getBack()
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };



  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <span
          className="flex  items-center cursor-pointer"
          onClick={() => getBack()}
        >
          <BiArrowBack className="h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2" />
          <span className="ml-2">{t("O_BACK")}</span>
        </span>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
           <div className="grid grid-cols-2 gap-x-6">
           <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="likes"
                id="likes"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("likes")}
                />

                <label
                  htmlFor="userFullName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_LIKES")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="comments"
                id="comments"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("comments")}
                />

                <label
                  htmlFor="comments"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_COMMENTS")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
           </div>
           <div className="grid grid-cols-2 gap-x-6">
           <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="postSaveCount"
                id="postSaveCount"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("postSaveCount")}
                />

                <label
                  htmlFor="postSaveCount"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SAVED")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="postReportCount"
                id="postReportCount"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("postReportCount")}
                />

                <label
                  htmlFor="postReportCount"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_MARK_AS_REPORT")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
           </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="createdAt"
                  id="createdAt"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("createdAt")}
                />
                <label
                  htmlFor="createdAt"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CREATED_AT")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  disabled
                  type="text"
                  rows='6'
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("description")}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                </label>
              </div>
            </div>
            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-white bg-red-500 font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                disabled={editData?.isDeleted}
                onClick={(e) =>
                  helper.alertFunction(
                    `${t('ARE_YOU_SURE_TO_DELETE_POST')}`,
                    editData,
                    handelDelete,
                    true
                  )
                }
              >
                {editData?.isDeleted ? t("O_DELETED") : t("O_DELETE") }
              </button>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                    Uploaded Audio
                  </h3>
                </div>
            {uploadedAudio?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedAudio?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                    Uploaded Images
                  </h3>
                </div>
            {uploadedImages?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedImages?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                    Uploaded Videos
                  </h3>
                </div>
            {uploadedVideos?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedVideos?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPostDetails;
